//# sourceMappingURL=document-node.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/document-node.interface.js
// module id = 1167
// module chunks = 4